export const getFullImagePath = (url: string) => {
  return `${url}`;
};
